import React from "react";
import { Leaf } from "lucide-react";
import ServicePage from "./ServicePage";
import img1 from "../../assets/images/jpg/img1.jpg";

const service = {
  title: "Landscaping Design & Build",
  icon: Leaf,
  image: img1,
  description:
    "Complete landscape design and build services for outdoor spaces that feel natural, practical, and beautifully finished.",
  longText:
    "From first concept to final planting, our landscaping design and build service covers layout planning, garden structure, softscaping, hardscaping, and finishing details. We help you create an outdoor area that suits your property, lifestyle, and maintenance needs.",
  points: [
    "Custom garden layout planning",
    "Planting and softscape design",
    "Pathways and outdoor features",
    "Residential and commercial projects",
    "Site preparation and finishing",
    "Low-maintenance landscape options",
  ],
};

export default function LandscapingDesignBuild() {
  return <ServicePage service={service} />;
}
